module.exports = __webpack_public_path__ + "static/media/bg-1440.79d322d2.jpg";